import LicenseTableRowViewModel from "./OrganisationTableRowViewModel";

export default class OrganisationTableViewModel {
    public count: number = 0;
    public rows: LicenseTableRowViewModel[] = [];
}